export default __webpack_public_path__ + "static/media/We Need You, You Know~.9ea86533.png";